<template>
    <div class="container-fluid content-type-42">
        <div class="container">
            <div class="row">
                <div class="col-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3">
                    <div class="content">
                        <h1 class="h2">{{ $t('views.company_register.title') }}</h1>
                        <div class="p description">{{ $t('views.company_register.description') }}</div>
                        <CompanyAutosuggest @select="onSelect" />
                        <SearchHistory @select="onSelect" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { useUserStore } from '@/stores/user';
    import CompanyAutosuggest from '@/components/search/CompanyAutosuggest';
    import SearchHistory from '@/components/search/SearchHistory';

    export default {
        name: "RegistryDetails",
        components: {
            CompanyAutosuggest,
            SearchHistory
        },
        methods: {
            onSelect(suggestion) {
                if(suggestion.id) {
                    const isAuthenticated = useUserStore().isAuthenticated;
                    const id = isAuthenticated && suggestion.id.includes('_') ? suggestion.id.split('_')[0] : suggestion.id;
                    this.$router.push({ name: 'company', params: { id } });
                }
            }
        }
    }
</script>